package fyi.moko.hotpl.domain.model

import kotlin.math.PI
import kotlin.math.atan2
import kotlin.math.cos
import kotlin.math.sin
import kotlin.math.sqrt

private fun Double.toRadians(): Double = this * PI / 180.0

/**
 * Returns the approximate distance in metres between [from] and [to] using the
 * Haversine formula. Replaces `android.location.Location.distanceBetween` so the
 * same calculation can run on iOS / Kotlin/Native.
 *
 * Lives in `domain` rather than `ui.home` because the directory search providers need
 * it too — a provider that returns coordinates but no distance (Nominatim) has its
 * distances computed here.
 */
fun haversineMeters(from: GeoPoint, to: GeoPoint): Float {
    val earthRadiusM = 6_371_000.0
    val dLat = (to.latitude - from.latitude).toRadians()
    val dLng = (to.longitude - from.longitude).toRadians()
    val lat1 = from.latitude.toRadians()
    val lat2 = to.latitude.toRadians()
    val a = sin(dLat / 2) * sin(dLat / 2) +
        cos(lat1) * cos(lat2) * sin(dLng / 2) * sin(dLng / 2)
    val c = 2 * atan2(sqrt(a), sqrt(1 - a))
    return (earthRadiusM * c).toFloat()
}
